import React from "react";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";

export class MapContainer extends React.Component {
  render() {
    return (
      <div id="google-map">
        <Map
          className="mt-2 overflow-hidden"
          containerStyle={{ height: "400px", position: "relative" }}
          style={{ height: "100%", width: "100%" }}
          google={this.props.google}
          zoom={this.props.zoom}
          initialCenter={this.props.initialCenter}
        >
          <Marker name={"Targ rybny"} />
        </Map>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyCZRcoMluYNAv9XP2dtItF2TC4Q7PtEhpM",
})(MapContainer);



// WEBPACK FOOTER //
// ./src/components/Map.js